var data = {
  "body": "<path d=\"M15 4v16.563L9.719 15.28L8.28 16.72l7 7l.719.687l.719-.687l7-7l-1.438-1.438L17 20.562V4zM7 26v2h18v-2z\" fill=\"currentColor\"/>",
  "width": 32,
  "height": 32
};
export default data;